import React from 'react';
import about from '../../../assets/images/about.jpg'
import Download from '../Download/Download';

const About = () => {
    return (
      <div className='pb-10' id='about'>
        <div className="text-center">
          <h2 className="text-3xl mb-5">About Me</h2>
        </div>
        <div className="hero ">
          <div className="hero-content flex-col lg:flex-row-reverse">
            <img
              src={about}
              className="max-w-sm rounded-lg shadow-2xl"
              alt=""
            />
            <div>
            <h3 className="text-2xl mb-5">
                Hey there, I am <span className='text-orange-400 font-semibold'>Merazur Rahman</span>
              </h3>
              <p className='text-xl'>
              Hello everyone, I am Md. Merazur Rahman.I am a front end developer based on the MERN stack. I have completed my bachelor of Science in Computer Science and Engineering at Daffodil International University. I have a piece of expertise knowledge in HTML, CSS, Git, Bootstrap, Tailwind, ReactJS, React Router,  React Bootstrap, SPA, and API. I am comfortable with NodeJS, ExpressJS, MongoDB, Firebase Authentication and Chrome Dev tools, and also familiar with JSON Web Token(JWT). I am confident, dynamic, committed, hard worker, quick learner and passionate about my work.
              </p>

              <div>
                <Download></Download>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default About;